import React from 'react';

// Card for `kind: "weather.correction"` — "your spot vs the Open-Meteo forecast"
// (weather-local-correction slug).
//
// Expected fields:
//   place           — location label (e.g. "Norwalk, CT 06854")
//   forecast_source — "Open-Meteo"
//   forecast_time   — ISO string (UTC) of the forecast sample
//   channels        — [{ label, key, unit, local, forecast, delta }]
//                     correctable channels the forecast also provides
//   local_only      — [{ label, key, unit, value }]
//                     readings the forecast can't resolve at your block
//   text            — markdown fallback
//
// Each channel shows local vs forecast with a signed, color-coded delta
// (warmer/higher = warm color, cooler/lower = cool color).
export default function WeatherCorrectionCard({ structured }) {
  const channels = structured.channels || [];
  const localOnly = structured.local_only || [];
  const place = structured.place || 'this station';
  const src = structured.forecast_source || 'the forecast';
  const when = structured.forecast_time
    ? ` · ${String(structured.forecast_time).replace('T', ' ')} UTC`
    : '';

  return (
    <div style={{
      marginBottom: '10px', padding: '12px', background: '#f8fafc',
      borderRadius: '8px', border: '1px solid #e2e8f0',
    }}>
      <div style={{
        fontSize: '0.85rem', fontWeight: 600, marginBottom: '2px',
        color: '#334155',
      }}>
        Your spot vs {src} — {place}
      </div>
      <div style={{ fontSize: '0.7rem', color: '#94a3b8', marginBottom: '10px' }}>
        local reading vs area forecast{when}
      </div>

      {channels.length === 0 && (
        <div style={{ fontSize: '0.8rem', color: '#64748b' }}>
          No overlapping channels to compare.
        </div>
      )}

      {channels.map((c, i) => {
        const up = c.delta >= 0;
        const deltaColor = up ? '#dc2626' : '#2563eb'; // warmer/higher red, cooler/lower blue
        const sign = up ? '+' : '';
        return (
          <div key={i} style={{
            display: 'flex', alignItems: 'baseline', justifyContent: 'space-between',
            padding: '4px 0', borderTop: i ? '1px solid #eef2f6' : 'none',
          }}>
            <span style={{ fontSize: '0.8rem', color: '#475569', minWidth: '72px' }}>
              {c.label}
            </span>
            <span style={{ fontSize: '0.8rem', color: '#334155', flex: 1, textAlign: 'right' }}>
              <b>{c.local}{c.unit}</b>
              <span style={{ color: '#94a3b8' }}> vs {c.forecast}{c.unit}</span>
            </span>
            <span style={{
              fontSize: '0.8rem', fontWeight: 700, color: deltaColor,
              minWidth: '64px', textAlign: 'right',
            }}>
              {sign}{c.delta}{c.unit}
            </span>
          </div>
        );
      })}

      {localOnly.length > 0 && (
        <div style={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
          {localOnly.map((e, i) => (
            <span key={i} style={{
              fontSize: '0.72rem', color: '#475569', background: '#eef2f6',
              borderRadius: '999px', padding: '2px 8px',
            }} title="the forecast can't resolve this at your block">
              {e.label} {e.value}{e.unit}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
